<script>
  import MarketArticle from 'src/pc/pages/MarketArticle'
  import PageLayout from '../layouts/PageLayout'
	export default {
    extends: MarketArticle,
    components: {
      PageLayout,
    },
    computed: {
      getAccess () {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .market_article .inner {
    padding: 0 !important;
  }
  .market_article .insta_ctnr {
    display: inline-block;
    width: 100%;
    background: #fff;
    border-bottom: 6px solid #f5f5f5;
  }
  .market_article .insta_ctnr .logo {
    padding: 12px 20px 12px;
  }
  .market_article .insta_ctnr .logo span {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #000;
    padding: 3px 4px;
    border-radius: 100%;
  }
  .market_article .insta_ctnr .logo span img {
    width: 100%;
  }
  .market_article .insta_ctnr .logo p {
    display: inline-block;
    font-size: 1.0em;
    font-weight: 900;
    line-height: 30px;
    margin-left: 8px;
  }
  .market_article .insta_ctnr .img img {
    max-width: 100%;
    max-height: 100%;
  }
  .market_article .insta_ctnr .article {
    padding: 20px 20px 25px 20px;
  }
  .market_article .insta_ctnr .article .subj {
    font-size: 1.5em;
    font-weight: 800;
    letter-spacing: -0.03em;
    padding-bottom: 15px;
  }
  .market_article .insta_ctnr .article .con {
    font-size: 1.0em;
    font-weight: 500;
    color: #444;
    letter-spacing: -0.02em;
    padding-bottom: 25px;
    line-height: 1.45em;
  }
  .market_article .insta_ctnr .article .con a {
    color: #379339;
    text-decoration: underline;
  }
  .market_article .insta_ctnr .article .tag i {
    display: block;
    font-size: 1.0em;
    font-weight: 700;
    padding-bottom: 6px;
  }
  .market_article .insta_ctnr .article .tag a {
    display: inline-block;
    margin-right: 6px;
    line-height: 1.6em;
    font-size: 1.0em;
    font-weight: 400;
    color: #379339;
  }
  .market_article .insta_ctnr .article .tag a:before {
    content: "#";
  }
  .market_article .insta_ctnr .article .tag a:hover {
    color: #000;
  }
  .market_article .insta_ctnr .article strong {
    font-weight: 800;
  }
  .market_article .insta_ctnr [data-f-id="pbf"] {
    display: none;
  }
</style>
